module.exports = __webpack_public_path__ + "static/svn-1aa8992d85e839e2fb6046ee14202e1d.png";